export default {
  title: 'Tische',
  count_one: '{{count}} Tisch',
  count_other: '{{count}} Tische',
  filtered_count: '{{shown}} von {{count}} Tischen',
  intro:
    'Jeder Tisch hat einen eigenen Link und QR-Code. Gäste, die ihn scannen, bestellen an diesen Tisch, und Sie sehen den Tisch bei jeder Bestellung.',
  migrated: {
    title: 'Zimmer-/Tischservice heißt jetzt Tischbestellung',
    description:
      'Wir haben für jeden Ihrer Standorte einen Tisch angelegt, benannt nach dem Standort, damit Gäste weiter bestellen können. Benennen Sie sie nach Ihren Tischen um oder fügen Sie weitere hinzu.',
  },
  add: {
    label: 'Tisch hinzufügen',
    placeholder: 'z. B. 7, 1A oder Terrasse 2',
    button: 'Tisch hinzufügen',
  },
  errors: {
    empty: 'Geben Sie einen Tischnamen ein.',
    duplicate: 'Es gibt schon einen Tisch namens „{{name}}“.',
    too_long: 'Ein Tischname darf höchstens {{max}} Zeichen haben.',
  },
  columns: {
    order: 'Reihenfolge',
    table: 'Tisch und Link',
    on: 'Aktiv',
    copy: 'Link kopieren',
    qr: 'QR-Code',
    actions: 'Aktionen',
  },
  switch: {
    on: 'An',
    off: 'Aus',
  },
  buttons: {
    copy: 'Link kopieren',
    copied: 'Kopiert',
    download_qr: 'QR-Code herunterladen',
    qr_short: 'QR-Code',
    rename: 'Umbenennen',
    delete: 'Löschen',
    save: 'Speichern',
    cancel: 'Abbrechen',
  },
  aria: {
    move: '{{name}} verschieben (Pfeiltasten)',
    switch: '{{name}} aktiv',
    copy: 'Link für {{name}} kopieren',
    copied: 'Link kopiert',
    download_qr: 'QR-Code für {{name}} herunterladen',
    rename: '{{name}} umbenennen',
    delete: '{{name}} löschen',
    more: 'Mehr für {{name}}',
    new_name: 'Neuer Name für {{name}}',
  },
  tooltips: {
    move: 'Zum Sortieren ziehen',
    move_disabled: 'Leeren Sie die Suche, um zu sortieren',
  },
  rename_hint: 'Link und QR-Code bleiben gleich.',
  no_link: 'Noch keine Shop-Adresse',
  search: {
    placeholder: 'Tische suchen',
    no_results: 'Kein Tisch namens „{{text}}“.',
  },
  load_failed: {
    title: 'Die Tische konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
  },
  empty: {
    title: 'Noch keine Tische',
    text: 'Fügen Sie oben Ihre Tische hinzu, um für jeden einen Link und QR-Code zu erhalten. Bis dahin können Gäste nicht am Tisch bestellen.',
  },
  delete: {
    title: 'Tisch „{{name}}“ löschen?',
    warning:
      'Gedruckte QR-Codes für diesen Tisch funktionieren dann nicht mehr. Gäste, die einen scannen, werden gebeten, sich an das Personal zu wenden.',
    softer: 'Um Bestellungen an diesem Tisch nur zu pausieren, schalten Sie ihn stattdessen aus.',
    confirm: 'Tisch löschen',
    cancel: 'Abbrechen',
  },
  announcements: {
    moved: '„{{name}}“ auf Position {{position}} von {{count}} verschoben.',
    instructions:
      'Um einen Tisch zu verschieben, fokussieren Sie seinen Griff und drücken Sie die Pfeiltaste nach oben oder unten.',
  },
  qr_image: {
    table: 'Tisch',
  },
  toasts: {
    added: 'Tisch „{{name}}“ hinzugefügt',
    renamed: '„{{old}}“ in „{{name}}“ umbenannt',
    deleted: 'Tisch „{{name}}“ gelöscht',
    switched_on: '„{{name}}“ eingeschaltet',
    switched_off: '„{{name}}“ ausgeschaltet',
    failed_to_save: 'Das wurde nicht gespeichert. Bitte versuchen Sie es erneut.',
    failed_to_reorder: 'Die neue Reihenfolge wurde nicht gespeichert. Bitte versuchen Sie es erneut.',
    failed_to_download_qr: 'Der QR-Code konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    copy_failed: 'Der Link konnte nicht kopiert werden. Bitte versuchen Sie es erneut.',
  },
};
